<template>
    <div class="o-support-modal support-modal">
        <button
            type="button"
            class="support-modal__close-button"
            :aria-label="ariaLabelSupportClose"
            @click="handleClose"
        >
            <svg-icon
                original
                name="icons/close"
                class="support-modal__close-button-icon"
            />
        </button>
        <div class="support-modal__header">
            <span class="support-modal__header-text">
                {{ $t('o-company-info_label' )}}
            </span>
            <svg-icon
                original
                name="icons/path-white"
                class="support-modal__header-icon"
            />
        </div>
        <button
            role="button"
            type="button"
            class="support-modal__logo"
            :aria-label="ariaLabelLogo"
            v-touch:touchhold="touchHoldHandler"
        >
            <svg-icon
                original
                name="dmds-logo"
                class="support-modal__logo-icon"
            />
        </button>
        <div class="support-modal__column-wrapper">
            <div class="support-modal__column">
                <div
                    class="support-modal__versions"
                    v-for="(item, index) in versions"
                    :key="index"
                >
                    <span class="support-modal__versions-heading">
                        {{ item.name }}
                    </span>
                    <span class="support-modal__versions-value">
                        {{ item.version }}
                    </span>
                </div>
            </div>
            <div class="support-modal__column">
                <svg-icon
                    original
                    name="qr-support"
                    class="support-modal__column-qr"
                />
                <span class="support-modal__qr-tip">
                    {{ $t('o-support-modal_qr-title') }}
                </span>
                <div class="support-modal__contacts">
                    <span v-if="isTerminal">
                        mediavisiongroup.se
                    </span>
                    <a
                        v-else
                        class="support-modal__link"
                        href="http://www.mediavisiongroup.se/"
                        target="_blank"
                    >
                        mediavisiongroup.se
                    </a>
                    <a
                        class="support-modal__link"
                        :href="`tel:${$t('support-modal-tel')}`"
                        target="_blank"
                    >
                        | {{ $t('support-modal-tel') }}
                    </a>
                </div>
            </div>
            <div class="support-modal__column">
                <div
                    class="support-modal__connection-indicator"
                >
                    <div
                        class="support-modal__swg-wrapper"
                        :class="{'support-modal__swg-wrapper-offline': !online}"
                    >
                        <svg-icon
                            original
                            name="icons/connection"
                            class="support-modal__connection-indicator-svg"
                        />
                        <span class="support-modal__connection-indicator-text">
                            {{online ? 'online' : 'offline'}}
                        </span>
                    </div>
                    <span
                        class="support-modal__connection-text"
                    >
                        <h3 class="support-modal__connection-text">Data revision: {{ dateConverter(lastModified) }}</h3>
                        <h3 v-if="isTerminal" class="support-modal__connection-text">Last check: {{ dateConverter(lastModifiedCheckedAt) }}</h3>
                        <h3 v-if="isMapDataUpdateNeeded" ><a @click.prevent="fetchMapData(mapId)">Update</a></h3>
                    </span>
                </div>
                <span class="support-modal__logo-label">
                    {{ $t('o-support-modal-collaboration') }}
                </span>
                <svg-icon
                    original
                    name="hospital-logo-white-bg"
                    class="support-modal__hospital-logo"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapState
} from 'vuex';

import {
    MapViewerIframeWindow,
    appVersion
} from '../../../utils/helpers/versions';
import dateConverter from '../../../utils/helpers/dateConverter';

export default {
    name: 'OSupportModal',
    props: {
        ariaLabelLogo: {
            type: String,
            default: 'Support logo'
        },
        ariaLabelSupportClose: {
            type: String,
            default: 'Support close button'
        }
    },
    data() {
        return {
            versions: [],
            online: true,
            checkOnlineInterval: null
        }
    },
    computed: {
        ...mapState({
            lastModified: state => state.lastModified,
            lastModifiedCheckedAt: state => state.lastModifiedCheckedAt,
            isMapDataUpdateNeeded: state => state.isMapDataUpdateNeeded,

        }),
        ...mapGetters([
            't',
            'getTerminal',
            'isTerminal',
        ]),
        mapId(){
            return parseInt(this.$route.params.mapId, 10);
        }
    },
    mounted() {
        this.getVersions();
        this.online = window.navigator.onLine;
        this.checkOnlineInterval = setInterval(() => {
            this.online = window.navigator.onLine
        }, 10000);
    },
    methods: {
        ...mapActions([
            'fetchMapData'
        ]),
        getVersions() {
            const iframe = MapViewerIframeWindow();
            this.versions = [
                {
                    name: 'ViewApi :',
                    version: iframe.ViewApi.version
                },
                {
                    name: 'MapViewer :',
                    version: iframe.mapsviewer_version
                },
                {
                    name: 'Application UI :',
                    version: appVersion
                }
            ];

            if (this.isTerminal) this.versions.push(
                {
                    name: 'Terminal :',
                    version: this.t(this.getTerminal, 'name')
                }
            )
        },
        handleClose() {
            this.$emit('onClose', true);
        },
        touchHoldHandler() {
            window.location.reload();
        },
        dateConverter: dateConverter,
        /*
        dateConverter(date) {
            return dateConverter(date*1000)
        }*/
    },
    beforeDestroy() {
        clearInterval(this.checkOnlineInterval)
    }
}
</script>

<style lang="scss">
@import "o-support-modal";
</style>
